import { AxiosResponse } from 'axios';

import {
  createCostCenterDetail,
  deleteCostCenterDetail,
  editCostCenterDetail
} from 'RestAPIs/admin';

import { showErrorSnackbar } from 'components/shared/Snackbar';

export const handleSaveCostCenterDetails = (data, deletedIds: number[]) => {
  if (data.costCenterDetails && data.costCenterDetails.length > 0) {
    const requestsArray: Promise<AxiosResponse>[] = [];

    data.costCenterDetails
      .filter((value) => value.isCommitted)
      .forEach((detail) => {
        const payload = {
          ...detail,
          finBrDynId: detail.finBrDynId?.value ?? null,
          parentBrDynId: detail.parentBrDynId?.value ?? null
        };

        if (payload.brDynId) {
          requestsArray.push(editCostCenterDetail(payload));
        } else {
          requestsArray.push(createCostCenterDetail(payload));
        }
      });

    deletedIds.forEach((id) => {
      requestsArray.push(deleteCostCenterDetail(id));
    });

    return Promise.all(requestsArray).catch((error) =>
      showErrorSnackbar(error)
    );
  }

  return Promise.resolve();
};
